import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './airtrafficfuture.json';

const AirtrafficFuture = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Future of aviation, drones, and aerospace vocabulary. B2/C1 level grammar, reading, and discussion exercises."
            level="B2"
            title="Air Traffic Future"
            image="/Images/airdelay1.webp"
            seoTitle="Free English Lesson Plans: Air Traffic and the Future"
            seoDescription="Future of aviation, drones, and aerospace vocabulary. B2/C1 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default AirtrafficFuture;


